import type { Hono } from 'hono';

export type AnyHono = Hono<any>;
